import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import StandardDialog from 'components/common/standard_dialog'
import { hide } from 'redux/modules/coming_soon_dialog'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/coming_soon_dialog')

class ComingSoonDialog extends React.Component {
  static propTypes = {
    visible: PropTypes.bool,
    dispatch: PropTypes.func,
  }

  handleClose = () => {
    this.props.dispatch(hide())
  }

  render() {
    if (!this.props.visible) {
      return null
    }

    return (
      <StandardDialog
        title={i18n('title')}
        subtitle={i18n('description')}
        closeButtonTitle={i18n('action')}
        onClose={this.handleClose}
        size="small"
      />
    )
  }
}

export default connect(state => ({
  visible: state.coming_soon_dialog.visible,
}))(ComingSoonDialog)
